import React from 'react';
import ImageZoom from 'react-medium-image-zoom';
import coverImg from '../../imgs/WorstDrivers/cover.png';
import comImg from '../../imgs/WorstDrivers/com.png';

const WorstDrivers = () => (
  <div className="caseBody">
    <h2>Which State Has the Worst Drivers</h2>
    <p className="caseIntro">Class Project</p>
    <img className="img-responsive img-centered" src={coverImg} alt="" />
    <h3 id="overview">My Roles</h3>
    <p className="content-p">
      <b>UI designer and Front-end developer</b> - I took in charge the
      interaction and design part of the visualization. I also implemented the
      choropleth and donut charts.
    </p>
    <h3 id="background">Story behind the visualization</h3>
    <p className="content-p">
      We were astonishing to see that millions of people die or injure in road
      crashes according to Road crash statistics. This drew our attention and we
      decided on analyzing which states have the worst drivers in the U.S. I
      looked into data and found the connections among some of the possible
      factors. In the visualization, we displayed the fatalities per one hundred
      million vehicle miles traveled on a U.S. map. We chose accident fatality
      to represent how bad the drivers are because fatality is the worst direct
      consequence of car accidents. Users can also use the slider under the map
      to change the observation year and see the distribution of bad drivers in
      the U.S. in that year. We want to show users the changes of the
      distribution over years. To help users get a better understanding of how
      bad drivers are distributed in the U.S., we also list the top 10 states
      with the highest fatality rate per one hundred million vehicle miles
      traveled in the selected year.
    </p>
    <p className="content-p">
      When users saw the overview of the year and the states that have the most
      fatalities, they may want to drill down to see some state level
      information. We provided this option for users to see the detail
      information of the selected state from the map. As user clicked a state in
      the U.S. map, the browser will scroll down and display fatalities,
      unemployment and murder rate in the selected state as a line graph. We
      wanted to show the similar tendency of these variables over years. Also,
      we added a average fatalities rate in the country to be compared with the
      state fatalities, so that users can see how bad the drivers in that state
      are comparing to the average level in the country.
    </p>
    <p className="content-p">
      As we discussed above, unemployment and murder rate could have positive
      impact on the car accidents fatality rate, which is usually an indirect
      result. However, the most immediate causes of car accidents are drunk
      driving and speeding. Therefore, we also showed how much percentage of
      fatalities was caused by these two factors in the selected state and year
      so that users may know what made these drivers bad.
    </p>
    <h3 id="dataCollection">Data Collection</h3>
    <p className="content-p">
      I collected the auto fatality data from{' '}
      <a href="http://www.nhtsa.gov">
        {' '}
        National highway traffic safety administration{' '}
      </a>
      . The first dataset we used was from the fatality analysis reporting
      system (FARS) of NHTSA, in which we retrieved the fatalities per one
      hundred million vehicle miles traveled for each state in the period of
      2004 to 2014.
    </p>
    <p className="content-p">
      To make assumptions of the cause of bad drivers in each states, we picked
      two variables, which were murder rate and unemployment rate, to see their
      relationship with car accident fatality rate by comparing them in the line
      graph. We picked these two variables because we read an article about what
      cause car accidents in a big pictures and these two factors were mentioned
      in the article. However, after the comparison in the line graph, we found
      that the relationship between the fatal rates and the unemployment rate is
      not close.
    </p>
    <h3 id="design">Design and Implementation</h3>
    <h4 className="sub-header">Part1: General Overview</h4>
    <p className="content-p">
      <b>Choropleth map and bar chart controlled with time slider</b>
      <br />
      The first part aims to provide a general overview on the general car
      accident condition in United States. I applied the albersUsa projection to
      produce the composition of all states in a single view, with the scale
      changing according to the size of window. The color of each state is
      assigned based on the fatalities rate per 100 million vehicle miles
      traveled, which is picked to factor out drivers numbers and other driving
      condition difference among states, therefore to focus on the
      characteristics of the drivers who were involved in fatal collisions. The
      visualization offers 10 years data, accessed and controlled with a year
      slider, implemented with a range input. To provide more details and a
      better support for the choropleth, we visualize the 10 states with highest
      fatal rate for this year, the the form of bar chart, aiming to offering
      the most intuitive and effective presentation.
    </p>
    <p className="content-p">
      I designed the visualization in this way so that users could gain a
      general idea about the fatal rate distribution among states, such as the
      which area has more fatal crashes. Users could also see a rough changing
      trend on car accidents in country scale.
    </p>
    <h4 className="sub-header">Part2: Task Analysis</h4>
    <p className="content-p">
      <b>Line graph with dual Y axes and pie charts</b>
      <br />
      To enable users digging deeper, I proposed the idea that provides users
      with more detailed data for each state, which could be access by clicking
      on the state they are interested in. Once a state is selected, the page
      will automatically scroll down to detail part, showing one line graph and
      four charts.
    </p>
    <p className="content-p">
      The line graph contains four variables. Two yellow­ based lines are
      visualizing the fatal rate of selected state and of US average, aiming to
      telling the changing trend over the ten years, as well as a comparison of
      the state performance over US average performance in fatal car accidents.
      The purple ­based lines are visualizing the murder rate and the
      unemployment rate in selected state, trying to lead and inspire users to
      think about, what might actually contribute to the car crashes events in
      an area. The top two donut charts show the percentages of fatalities
      caused by drunk driving and speeding respectively for the selected state
      in the selected year. The bottom two donut charts show the percentages of
      fatalities caused by drunk driving and speeding in the USA in the selected
      year.
    </p>
    <p className="content-p">
      Through the design of donut charts, we want to help users understand how
      serious alcohol and speeding are affecting the highway fatalities in a
      specific state comparing to the whole country.
    </p>
    <p className="content-p">
      You can play around this visualization via the link below the picture!
    </p>
    <br />
    <p className="content-p">
      <a
        className="demo-link"
        href="http://awwmeow.github.io/Project-3-Which-State-Has-the-Worst-Drivers/"
        rel="noopenner noreferrer"
        target="_blank"
      >
        Live Demo →
      </a>
    </p>
    <br />
    <ImageZoom
      image={{
        src: comImg,
        alt: '',
        className: 'img-responsive img-centered'
      }}
    />
  </div>
);

export default WorstDrivers;



// WEBPACK FOOTER //
// ./src/Modules/Case/WorstDrivers.js